module.exports = {
  BASEAPI: process.env.VUE_APP_API_BASE_URL,
  IMAGE_API: process.env.VUE_APP_API_IMGAE,
};
